import React from 'react';
import styled from 'styled-components';
import { lightGrey2Color, blueColor } from 'js/config/style';

const Container = styled.div`
  grid-area: status;
`;

const Status = styled.span`
  padding: 0.25rem 0.5rem;
  border: 1px solid ${lightGrey2Color};
  border-radius: 0.25rem;
  background: ${blueColor};
  color: white;
`;

export default ({ children }) => (
  <Container>
    <Status>{children}</Status>
  </Container>
);
